import ajax from './index'
import apiEnv from './apiEnv'
// 获取试题库列表
export function questionBankList(data) {
    return ajax.post(`${apiEnv.api2}/questionBank/list`, data)
}
// 批量更新
export function questionBankBatchModi(data) {
    return ajax.post(`${apiEnv.api2}/questionBank/batchModi`, data)
}
// 批量删除
export function questionBankBatchDel(data) {
    return ajax.post(`${apiEnv.api2}/questionBank/batchDel`, data)
}
// 试题 新增/修改
export function questionBankModel(data) {
    return ajax.post(`${apiEnv.api2}/questionBank/modi`, data)
}
// 导入excel 
export function uploadExcelExcelImport(data) {
    return ajax.postForm(`${apiEnv.api2}/questionBank/excelImport`, data)
}
// 批量更新/批量删除/编辑/删除 判断接口
export function questionBankIsExist(data) {
    return ajax.post(`${apiEnv.api2}/questionBank/isExist`, data)
}


//认证/课程 考试列表
export function examinationExamList(data) {
    return ajax.post(`${apiEnv.api2}/exam/list`, data)
}
//发布/取消发布
export function examinationIsPublish(data) {
    return ajax.post(`${apiEnv.api2}/exam/isPublish`, data)
}
// 认证/考试 提交/编辑
export function examinationSet(data) {
    return ajax.post(`${apiEnv.api2}/exam/set`, data)
}

// 对应领域|产品|品牌下的对应题目数量查询
export function questionBankCountByFpbId(data) {
    return ajax.post(`${apiEnv.api2}/questionBank/countByFpbId`, data)
}
// 随机组题 (点击添加试题)
export function questionBankRandom(data) {
    return ajax.post(`${apiEnv.api2}/questionBank/random`, data)
}
// 题目数量查询--（包含关系）
export function questionBankQueryNum(data) {
    return ajax.post(`${apiEnv.api2}/questionBank/queryNum`, data)
}

// 认证/课程 列表删除
export function examinationDel(data) {
    return ajax.post(`${apiEnv.api2}/exam/del`, data)
}

// 认证/课程 回显
export function examinationSetEcho(data) {
    return ajax.post(`${apiEnv.api2}/exam/setEcho`, data)
}

// 考试成绩列表
export function examResoultList(data) {
    return ajax.post(`${apiEnv.api2}/examResoult/list`, data)
}
// 考试成绩列表删除
export function examResoultDel(data) {
    return ajax.post(`${apiEnv.api2}/examResoult/del`, data)
}


// // 获取关联课程
// export function getExamCourseSelec(){
//     return ajax.get(`${apiEnv.api2}/exam/courseSelect`)
// }


// 报错记录
export function questionBankErrorRecord(data) {
    return ajax.post(`${apiEnv.api2}/questionBank/errorRecord`, data)
}


// 国家认证 || 原厂认证列表
export function configList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/auth/config/list`, data)
}
// 国家认证|原厂认证-发布|取消发布|删除
export function configPublishOrDel(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/auth/config/publishOrDel`, data)
}
// 国家认证 || 原厂认证 新增或修改
export function configAddOrModi(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/auth/config/addOrModi`, data)
}
// 国家认证|原厂认证详情
export function configDetails(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/auth/config/details`, data)
}
// 国家认证-面试|原厂认证-考核列表
export function accRecordList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/auth/accRecord/list`, data)
}
// 国家认证|原厂认证-面试通过|不通过
export function authStatusModi(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/auth/accRecord/authStatus/modi`, data)
}
// 大咖审核列表
export function expertList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/auth/expert/list`, data)
}
// 大咖审核通过 || 审核不通过
export function expertModi(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/auth/expert/applystatus/modi`, data)
}
// 考试技能下拉
export function optionServiceSelect() {
    return ajax.post(`${apiEnv.api2}/crm/option/serviceStageX`)
}



// 自动化模拟考试-用户详情
export function autoExamEngineerDetail(data) {
    return ajax.post(`${apiEnv.api2}/autoExamEngineer/info/detail`, data)
}
// 自动化模拟考试-用户详情审核
export function autoExamEngineerDetailAudit(data) {
    return ajax.post(`${apiEnv.api2}/autoExamEngineer/info/detail/audit`, data)
}
// 自动化模拟考试-用户资料-编辑
export function autoExamEngineerInfoEdit(data) {
    return ajax.post(`${apiEnv.api2}/autoExamEngineer/info/edit`, data)
}
// 自动化模拟考试-用户资料-列表
export function autoExamEngineerInfoList(data) {
    return ajax.post(`${apiEnv.api2}/autoExamEngineer/info/list`, data)
}
// 自动化模拟考试-用户资料-导出
export function autoExamEngineerInfoListExport(data) {
    return ajax.get(`${apiEnv.api2}/autoExamEngineer/info/list/export?${data}`)
}
// h5培训报名
export function getAutoEngineerApplyList(data) {
    return ajax.post(`${apiEnv.api4}/api/AutoEngineerApply/GetAutoEngineerApplyList`, data)
}